<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import index from './view/index.vue'

export default {
	name: 'app',
	components: { index }
}
</script>

<style type="text/css">
/* 首页置灰 */
.gray {
	
}

* {
	padding: 0;
	margin: 0;
	font-size: 14px;
	color: #FFFFFF;
}

a {
	text-decoration: none;
	color: #333333;
}

html,
body,
#app {
	min-height: 100%;
}

html,
body {
	height: 100%;
	overflow: auto;
	margin: 0;
}
</style>
